import { Component } from '@angular/core';
import { assets } from '../../core/constants/assets.const';

@Component({
  selector: 'mindbase-route-verification',
  standalone: true,
  imports: [],
  template: `<div class="ndf">
    <figure class="not-found ">
      <img class="not-found-image" [src]="assetsConst.noTanant" />
    </figure>
  </div>`,
  styles: [
    `
    .ndf {
      text-align: center;
      .not-found-image {
        margin-top:12%;
      }
    }
  `
  ]
})
export class RouteVerificationComponent {
  protected assetsConst = assets;
}
